import React from "react";
import { useAuth } from "../../context/AuthContext";
import GlassCard from "../../components/ui-custom/GlassCard";
import Reveal from "../../components/ui-custom/Reveal";
import { LogOut } from "lucide-react";

const MyAccount = () => {
  const { user, logout } = useAuth();

  return (
    <Reveal>
      <GlassCard className="p-8 max-w-2xl">
        <div className="flex items-center gap-5 mb-8">
          {user?.picture ? (
            <img src={user.picture} alt={user.name} className="w-16 h-16 rounded-full border border-qcyan/40 object-cover" />
          ) : (
            <span className="w-16 h-16 rounded-full flex items-center justify-center font-display font-bold text-xl bg-qcyan/10 border border-qcyan/30 text-qcyan">
              {user?.name?.[0] || "U"}
            </span>
          )}
          <div>
            <h3 className="font-display font-semibold text-foreground text-lg">{user?.name}</h3>
            <p className="text-sm text-muted-foreground">{user?.email}</p>
          </div>
        </div>
        <div className="grid sm:grid-cols-2 gap-5 text-sm">
          <div className="border border-border/10 rounded-lg p-4">
            <p className="text-muted-foreground text-xs uppercase tracking-wide mb-1">Account Type</p>
            <p className="text-foreground">Client Partner</p>
          </div>
          <div className="border border-border/10 rounded-lg p-4">
            <p className="text-muted-foreground text-xs uppercase tracking-wide mb-1">Sign-in Method</p>
            <p className="text-foreground">Google Sign-In</p>
          </div>
        </div>
        <button
          onClick={logout}
          className="mt-8 inline-flex items-center gap-2 text-sm font-semibold text-red-400 hover:text-red-300 transition-colors"
        >
          <LogOut size={16} /> Sign Out
        </button>
      </GlassCard>
    </Reveal>
  );
};

export default MyAccount;
